import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-substract",
  templateUrl: "./med-icon-substract.component.html",
})
export class MedIconSubstractComponent extends SvgMixinComponent {}
